"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clinicianPayerContractStatusTypes = void 0;
var clinicianPayerContractStatusTypes = {
  Archived: 'archived',
  Completed: 'completed',
  InProgress: 'in-progress',
  Pending: 'pending',
  Terminated: 'terminated'
};
exports.clinicianPayerContractStatusTypes = clinicianPayerContractStatusTypes;